import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Button, Calendar, Modal, Select } from '@opendate-app/setlist';

const dayOnly = (value) => {
  const match = value && String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  return match ? new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3])) : null;
};

export const dayMapName = (date) => date.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' });

const DaySeatMapModal = ({ seatingCharts, seatingChartEvent, showStart, showEnd, saving, onSave, onClose }) => {
  const renaming = !!seatingChartEvent;
  const [night, setNight] = useState(null);
  const name = night ? dayMapName(night) : '';
  const [seatingChartId, setSeatingChartId] = useState(seatingCharts[0]?.id ?? null);
  const canSave = name.trim().length > 0 && (renaming || seatingChartId !== null) && !saving;

  return (
    <Modal
      open
      onClose={onClose}
      title={renaming ? 'Rename day seat map' : 'Add a seat map for a day'}
      description={renaming ? null : 'Fans pick a seat for this day in the festival widget.'}
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>Cancel</Button>
          <Button variant="primary" disabled={!canSave} onClick={() => onSave({ name: name.trim(), seatingChartId })}>
            {renaming ? 'Save' : 'Add seat map'}
          </Button>
        </>
      }
    >
      <p className="mb-1"><strong>Night</strong>{name ? `: ${name}` : (renaming ? `: ${seatingChartEvent.name}` : '')}</p>
      <Calendar
        value={night}
        onChange={setNight}
        defaultMonth={dayOnly(showStart)}
        min={dayOnly(showStart)}
        max={dayOnly(showEnd || showStart)}
      />
      {renaming ? null : (
        <Select
          label="Seat map"
          options={seatingCharts.map((seatingChart) => ({ value: seatingChart.id, label: seatingChart.name }))}
          value={seatingChartId}
          onChange={setSeatingChartId}
        />
      )}
    </Modal>
  );
};

DaySeatMapModal.propTypes = {
  seatingCharts: PropTypes.array.isRequired,
  seatingChartEvent: PropTypes.object,
  showStart: PropTypes.string,
  showEnd: PropTypes.string,
  saving: PropTypes.bool,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

DaySeatMapModal.defaultProps = {
  seatingChartEvent: null,
  showStart: null,
  showEnd: null,
  saving: false,
};

export default DaySeatMapModal;
